export default [
    {
        path: '*',
        redirect: {
            path: '/404'
        }
    },
    {
        path: '/',
        name: 'HomePage',
        component: () => import (`@/views/HomePage.vue`)
    },
    {
        path: '/delete-account',
        name: 'DeleteAccount',
        component: () => import (`@/views/TravellerAccountDelete.vue`)
    },
    ,
    {
        path: '/traveller-login',
        name: 'TravellerLogin',
        component: () => import (`@/views/TravellerLogin.vue`)
    },
    {
        path: '/verify-otp',
        name: 'VerifyOTP',
        component: () => import (`@/views/VerifyDummyOTP.vue`)
    },
    {
        path: '/visa-application-track',
        name: 'VisaApplicationTrack',
        component: () => import (`@/views/track/VisaApplicationTrack.vue`)
    },
    ,
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: () => import (`@/views/PrivacyPolicy.vue`)
    },
    {
        path: '/404',
        name: 'NotFound',
        component: () =>
            import (
                /* webpackChunkName: "routes" */
                `@/views/errors/NotFound.vue`
                )
    },
    {
        path: '/403',
        name: 'AccessDenied',
        component: () =>
            import (
                /* webpackChunkName: "routes" */
                `@/views/errors/Deny.vue`
                )
    },
    {
        path: '/500',
        name: 'ServerError',
        component: () =>
            import (
                `@/views/errors/Error.vue`
                )
    },
    {
        path: '/on-arrival/:office',
        name: 'OnArrival',
        component: () =>
            import (
                `@/views/SelectLanguage.vue`
                )
    },
    {
        path: '/entry-visa-processing',
        name: 'EntryVisaProcessing',
        component: () =>
            import (
                `@/views/EntryVisaProcessing.vue`
                )
    },
    {
        path: '/online',
        name: 'OnlineApplication',
        component: () => import (`@/views/SelectLanguage.vue`)
    },
    {
        path: '/visa-check',
        name: 'PublicVisaCheck',
        component: () => import (`@/views/PublicVisaCheck.vue`)
    },
    {
        path: '/permit-check',
        name: 'PublicTrekkingPermitCheck',
        component: () => import (`@/views/PublicTrekkingPermitCheck.vue`)
    },
    {
        path: '/qr',
        name: 'QRVisaCheck',
        component: () => import (`@/views/QRVisaCheck.vue`)
    },
    {
        path: '/qrTrekking',
        name: 'QRTrekkingPermitCheck',
        component: () => import (`@/views/QRTrekkingPermitCheck.vue`)
    },
    {
        path: '/transaction-failure/:submission_no',
        name: 'TransactionFailure',
        component: () => import (`@/views/transaction/Failure.vue`)
    },
    {
        path: '/transaction-success/:submission_no',
        name: 'TransactionSuccess',
        component: () => import (`@/views/transaction/Success.vue`)
    },
    {
        path: '/transaction/gov-pay/failure/',
        name: 'TransactionGovPayFailure',
        component: () => import (`@/views/transaction/GovPayFailure.vue`)
    },
    {
        path: '/transaction/gov-pay/success',
        name: 'TransactionGovPaySuccess',
        component: () => import (`@/views/transaction/GovPaySuccess.vue`)
    },
    {
        path: '/verify-email/:apply/:office',
        name: 'verifyEmailEta',
        component: () =>
            import (
                `@/views/VerifyEmail.vue`
                )
    },
    {
        path: '/print-application/:apply/:office',
        name: 'PrintApplication',
        component: () =>
            import (
                `@/views/VisaApplicationPrint.vue`
                )
    },
    {
        path: '/arrival-visa-select/:apply/:office',
        name: 'SelectArrivalVisa',
        component: () =>
            import (
                `@/views/arrival/SelectVisa.vue`
                )
    },
    {
        path: '/visa-application/:apply/:office/:type/',
        name: 'VisaApplication',
        props: true,
        component: () =>
            import (
                `@/views/arrival/VisaApplication.vue`
                )
    },
    {
        path: '/visa-application-confirm/:apply/:office',
        name: 'ConfirmApplication',
        props: true,
        component: () =>
            import (
                `@/views/arrival/ArrivalConfirm.vue`
                )
    },
    {
        path: '/visa-convert-confirm',
        name: 'ConvertConfirm',
        props: true,
        component: () =>
            import (
                `@/views/convert/ConvertConfirm.vue`
                )
    },
    {
        path: '/visa-extend-confirm',
        name: 'ExtendConfirm',
        props: true,
        component: () =>
            import (
                `@/views/extend/ExtendConfirm.vue`
                )
    },
    {
        path: '/overstay-form',
        name: 'OverstayForm',
        props: true,
        component: () =>
            import (
                `@/views/OverstayForm.vue`
                )
    },
    // {
    //     path: '/self-entry',
    //     name: 'SelfEntry',
    //     props: true,
    //     component: () =>
    //         import (
    //             `@/views/SelfEntry.vue`
    //             )
    // },
    {
        path: '/visa-extend-form',
        name: 'ExtendForm',
        props: true,
        component: () =>
            import (
                `@/views/extend/ExtendForm.vue`
                )
    },
    {
        path: '/visa-convert-form',
        name: 'ConvertForm',
        props: true,
        component: () =>
            import (
                `@/views/convert/ConvertForm.vue`
                )
    },
    {
        path: '/visa-processing',
        name: 'ExtendChangeVisa',
        meta: {
            title: 'Tourist portal : Extend/Convert '
        },
        props: true,
        component: () =>
            import (
                `@/views/VisaProcessing.vue`
                )
    },
    {
        path: '/visa-visit-details',
        name: 'VisaHistory',
        props: true,
        component: () =>
            import (
                `@/views/ExtendConvertSelectForm.vue`
                )
    },
    {
        path: '/arrival-departure-certification-confirm',
        name: 'ArrivalDepartureCertificationConfirm',
        component: () =>
            import (
                `@/views/certification/ArrivalDepartureCertificationConfirm.vue`
                )
    },
    {
        path: '/visa-transfer-confirm',
        name: 'VisaTransferConfirm',
        component: () =>
            import (
                `@/views/transfer/TransferConfirm.vue`
                )
    },
    {
        path: '/visa-upgrade-confirm',
        name: 'VisaUpgradeConfirm',
        component: () =>
            import (
                `@/views/plan/VisaUpgradeConfirm.vue`
                )
    },
    {
        path: '/print-form',
        name: 'PrintForm',
        component: () =>
            import (
                `@/views/PrintForm.vue`
                )
    },
    {
        path: '/non-visa-arrival-departure-certification',
        name: 'NonTouristCertification',
        component: () =>
            import (
                `@/views/certification/NonTouristCertification.vue`
                )
    },
    {
        path: '/eta-visa-processing',
        name: 'OnlineEtaApplication',
        component: () => import (`@/views/EtaVisaProcessing.vue`)
    },
]
